import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  HeaderComponent,
  PaginationComponent, CustomButton
} from "@comps/components";
import { makeRequest, makeRequestStateless } from "@utils/helpers";
import { Commons, Const, colors } from "../constants";
import { Badge, Popover, Tooltip, message } from 'antd';
import { FilterComponent, FilterButton, ButtonComponent } from "@comps/components";
import { cancelPayrollRunReq, closePayrollDataReq, deleteDataReq, getAllDataReq, getFilterReq, reopenPayrollReq } from "./requests";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RunPayroll from "./RunPayroll";
import { CloseOutlined, SettingOutlined } from "@ant-design/icons";
import PayrollWorkspace from "./PayrollWorkspace";
import PayrollEmployeesManager from "./PayrollEmployeesManager";
import { convertTimeTotz } from '@comps/commonFunctions';
import { PlayArrowOutlined, RefreshOutlined, StopOutlined, WorkspacePremium } from "@mui/icons-material";
import { pusherInitializer, decryptLocalData } from "@comps/commonFunctions"
import dayjs from 'dayjs'
import { getBatchProgressByIdReq } from "../../../containers/components/header/requests";
import { cancelPayrollJobReq } from "../../common/requests";
import { TeamOutlined } from "@ant-design/icons";
const langKey = Const["payroll"].lngKey;
const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["payroll"].route
      }
    ]
  }
}

const IndexPayrolls = (props) => {
  const authUser = useSelector((state) => state.auth.authUser);
  const navigate = useNavigate();
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  const [allData, setAllData] = useState({});
  const [filters, setFilters] = useState(props.attendanceof === 'my' ? `employee_|${authUser.employment_id}` : '');
  const [statuses, setStatuses] = useState([]);

  //start pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });
  //end pagination states
  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================

  const columns = [
    {
      key: trans(Commons.name),
      title: trans(Commons.name),
      render: (record) => {
        return <>
          <span>{ record.name }</span><br />
          <small className="text-secondary">{ record.code }</small>
        </>
      }
    },
    {
      key: "Employees",
      title: "Employees",
      render: (record) => (
        <ButtonComponent
          onClick={ () => onManageEmployees(record) }
          icon={ <TeamOutlined /> }
          text={ `${record.emp_count || 0}` }
        />
      )
    },
    // {
    //   key: 'workspace',
    //   title: "Workspace",
    //   render: (record) => {
    //     return <Popover title="Click to View Payroll,Policies,Salary sheet,Payslips,Payitems,Formulas etc"><ButtonComponent
    //       onClick={ () => onOpenWorkspace(record) }
    //       icon={ <SettingOutlined /> }
    //       text={ `Workspace` }
    //     /></Popover>
    //   }
    // },
    {
      key: 'month',
      title: trans(`${langKey}.month`),
      render: (record) => (
        record.history ? dayjs(record.history.month).format('YYYY MMMM') : null
      )
    },
    {
      key: 'running_date',
      title: trans(`${langKey}.running_date`),
      render: (record) => (
        record.history && record.history.running_date ? (convertTimeTotz(record.history.running_date).format('YYYY MMMM DD h:m a')) : null
      )
    },
    {
      key: 'status',
      title: trans(`${langKey}.status`),
      render: (record) => (
        record.history &&
        <Badge
          styles={ { cursor: 'pointer' } }
          onClick={ () => onRun(record) }
          count={ record.history.status }
          style={ { background: colors[record.history.status_class], color: colors[record.history.status_class + '-color'] } }
        />
      )
    },
    {
      key: 'closing_date',
      title: trans(`${langKey}.closing_date`),
      render: (record) => (
        record.history && record.history.closing_date ? (convertTimeTotz(record.history.closing_date).format('YYYY MMMM DD h:m a')) : null
      )
    },
    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onEdit={ onEdit }
          onView={ onView }
          onDelete={ onDelete }
          disabledActions={ {
            delete: record.emp_count > 0 && 'This payroll already has employees assigned, so it cannot be deleted.',
          } }
          extraActions={ getRowActions(record) }
        >
          <Tooltip title="Open payroll workspace">
            <ButtonComponent onClick={ () => onOpenWorkspace(record) } text="Workspace" />
          </Tooltip>
        </ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================
  //==========================Start Pusher=================================
  useEffect(() => {
    const user = decryptLocalData('user');
    if (!user || !user.tenant) {
      return;
    }
    const pusher = pusherInitializer();
    const channel = pusher.subscribe(user.tenant);
    channel.bind('bell-notification-event', function (data) {
      getAllData();
    });
    // Cleanup function for unsubscribing and unbinding when the component is unmounted
    return () => {
      // Unbind the event handler
      channel.unbind('bell-notification-event');
      // Unsubscribe from the channel
      pusher.unsubscribe(user.tenant);
      // Disconnect from Pusher
      pusher.disconnect();
    };
    // eslint-disable-next-line
  }, []);

  //==========================end Pusher =================================
  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [filters, currentPage]);

  const getAllData = () => {
    const payload = {
      page: currentPage,
      filters: filters
    }
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, onGetAllDataError);
  };
  const onSuccess = (response) => {
    setAllData(response);
    setPagination(response.payrolls);
    setDataSource(response.payrolls.data);
  };
  const onGetAllDataError = (err, res) => {
    message.error(res.response.data.message);
  }

  const onEdit = (record) => {
    navigate(`/payrollmanagement/payrolls/edit/${record.id}`);
  };
  const onView = (record) => {
    navigate(`/payrollmanagement/payrolls/view/${record.id}`);
  };
  const onRun = (record) => {
    setChildComponent(<RunPayroll onCompleted={ onRunCompleted } record={ record } authUser={ authUser } allData={ allData } disabled={ false } />);
  };
  const onManageEmployees = (record) => {
    setChildComponent(
      <PayrollEmployeesManager
        record={ record }
        onRefresh={ getAllData }
        onCompleted={ () => setChildComponent(null) }
      />
    );
  };
  const onOpenWorkspace = (record) => {
    setChildComponent(
      <PayrollWorkspace
        record={ record }
        authUser={ authUser }
        allData={ allData }
        modkey={ props.modkey }
        onRefresh={ getAllData }
        onCompleted={ () => setChildComponent(null) }
      />
    );
  };
  const onRunCompleted = (data) => {
    if (data) {
      getAllData();
    }
    setChildComponent(null)
  }

  const onClose = (record) => {
    const payload = {
      payroll: record.id
    }
    makeRequest(setLoader, closePayrollDataReq, payload, onClosed, onError);
  };
  const onReopen = (record) => {
    const payload = {
      payroll: record.id
    }
    makeRequest(setLoader, reopenPayrollReq, payload, onReopened, onError);
  };
  const onReopened = (res) => {
    getAllData();
    message.success("Payroll Reopening please wait!");
  };

  const onDelete = (record) => {
    const payload = {
      filters: `employee_|${record.employment_id}`, id: record.id
    }
    makeRequest(setLoader, deleteDataReq, payload, onDeleted, onError);
  };
  const onCancelRunning = (record) => {
    makeRequest(setLoader, cancelPayrollJobReq, record.id, getAllData, onError);
  };

  // ==================================
  //   Row actions
  // ==================================
  // Only the payroll-specific conditions live here; ActionComponent handles the
  // disabled-instead-of-hidden rendering, the permission check, the confirm
  // dialog and the click guard for every entry below.
  const getRowActions = (record) => {
    const history = record.history;
    const isRunning = history && history.status === 'Running';
    const isClosed = history && history.is_closed;

    return [
      isRunning
        ? {
          key: 'run', tone: 'cancel', title: 'Cancel Running', icon: <CloseOutlined />,
          permission: 'update', label: 'cancel a running payroll for',
          onClick: () => onCancelRunning(record),
        }
        : {
          key: 'run', tone: 'run', title: 'Run payroll', icon: <PlayArrowOutlined />,
          permission: 'update', label: 'run',
          disabled: isClosed && 'This payroll is closed. Re-open it before running again.',
          onClick: () => onRun(record),
        },
      isClosed
        ? {
          key: 'close', tone: 'reopen', title: 'Re-open', icon: <RefreshOutlined />,
          permission: 'update', label: 're-open',
          confirm: 'Are you sure to Reopen to run again of previous month?',
          onClick: () => onReopen(record),
        }
        : {
          key: 'close', tone: 'close', title: 'Close payroll', icon: <StopOutlined />,
          permission: 'update', label: 'close',
          disabled: !(history && history.is_run) && 'This payroll has not been run yet, so there is nothing to close.',
          confirm: 'Are you sure to close?',
          onClick: () => onClose(record),
        },
    ];
  };

  const onDeleted = (res) => {
    setDataSource(res.payrolls.data);
    onSuccess(res)
    message.success("Record Deleted")
  };
  const onClosed = (res) => {
    getAllData();
    message.success("Payroll Closing please wait!");
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  // Create component modal
  const onCreate = () => {
    navigate('/payrollmanagement/payrolls/create');
  };

  const onCompleted = (data) => {
    if (data.length) {
      getAllData()
    }

    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);

  }

  //----end filter--------------------

  return (
    <>

      { childComponent }
      <BodyComponent>
        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
          {/* <CustomButton text="Payroll workspace" onClick={ () => dataSource[0] && onOpenWorkspace(dataSource[0]) } disabled={ dataSource.length < 1 } /> */ }
          <RefreshButton onClick={ getAllData } />
          <CreateButton onClick={ onCreate } />
          <FilterButton onClick={ onOpenFilter } />
        </HeaderComponent>
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
        />
      </BodyComponent>
      <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
    </>
  );
};

export default IndexPayrolls;
const filterFields = [
  {
    type: "text",
    placeholder: "Name",
    key: "name"
  },
  {
    type: "text",
    placeholder: "Code",
    key: "code"
  },
]
